import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import "../styles/TaskFilter.css";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { fetchProjects } from "../redux/actions/projectAction";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialFilterState = {
  project: "",
};

interface FilterProps {
  filters: typeof initialFilterState;
  onFilterChange: (field: string, value: string) => void;
  onFind: () => void;
  onReset: () => void;
}

const PageFilter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onReset,
  onFind,
}) => {
  const dispatch = useDispatch<any>();
  const projects = useSelector((state: StoreState) => state.project);

  const [lastAppliedFilters, setLastAppliedFilters] =
    useState(initialFilterState);

  const handleFindClick = () => {
    if (!filters.project) {
      toast.warning("Please select at least one project before searching.");
      return;
    }
    localStorage.setItem("PageFilters", JSON.stringify(filters));
    setLastAppliedFilters(filters);
    onFind();
  };

  const handleDropdownChange = (name: string, value: string) => {
    onFilterChange(name, value);
  };

  const renderDropdown = (
    label: string,
    name: string,
    value: string,
    options: { id: string; name: string }[] | string[],
  ) => (
    <Form.Group
      as={Col}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="task-filter-field"
      controlId={name}
    >
      <div className="dropdown-label">{label}</div>
      <Form.Select
        value={value}
        onChange={(e) => handleDropdownChange(name, e.target.value)}
        className="custom-select"
      >
        <option value="">All</option>
        {options.map((opt, idx) =>
          typeof opt === "string" ? (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ) : (
            <option key={idx} value={opt.id}>
              {opt.name}
            </option>
          ),
        )}
      </Form.Select>
    </Form.Group>
  );

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  return (
    <Form className="task-filter-form">
      <ToastContainer />
      <Row className="g-2 align-items-end">
        {renderDropdown(
          "Project",
          "project",
          filters.project,
          projects.map((p) => ({ id: p.id.toString(), name: p.name })),
        )}

        <Col xs={12} className="d-flex justify-content-end">
          <Button variant="primary" onClick={handleFindClick} className="m-1">
            Find
          </Button>
          <Button variant="secondary" onClick={onReset} className="m-1">
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PageFilter;
